/* eslint-disable prettier/prettier */
import React from 'react';

import Layout from '@/components/Layout';
// import Hero from '@/components/Hero';
import { Box, Text, Container, Flex, Divider } from 'theme-ui';
import Halo from '@/components/Halo';
// import { AqueraLogo, GamezyLogo } from '@/components/Icon';
import Anima from '@/components/Anima';
// import Animax from '@/components/Animax';
import TalkBlock from '@/components/TalkBlock';
import HeroAlt from '@/components/HeroAlt';
// import { Link } from 'gatsby';

/**
 * Card
 * @returns
 */

interface CardBlockProps {
  title: string;
  desc: string;
  color: string;
  stemColor: string;
  lineLength: number;
  strokeWidth: number;
  showStem: boolean;
}

// color: string;
//   stemColor: string;
export function CardBlock({
  title,
  desc,
  color,
  stemColor,
  lineLength,
  strokeWidth,
  showStem,
}: CardBlockProps) {
  return (
    <Box sx={{ maxWidth: [`100%`, `100%`, `30%`], mr: 0, mb: [6, 3, 3] }}>
      <Box
        sx={{
          mb: 4,
          // bg: `grays.2`,
          width: [`25%`, `100%`, `25%`],
          height: 102,
          // border: `solid 1px`,
          borderColor: `grays.2`,
        }}
      >
        <Anima
          color={color}
          stemColor={stemColor}
          lineLength={lineLength}
          strokeWidth={strokeWidth}
          zoom={5}
          showStem={showStem}
        />
      </Box>
      <Text as="h3" sx={{ fontSize: [3, 4, 3], mb: 1, fontWeight: `Bold` }}>
        {title}
      </Text>
      <Text
        as="p"
        sx={{
          fontSize: 2,
          mr: [0, 6, 6],
          color: `dimText2`,
          fontWeight: `body`,
        }}
      >
        {desc}
      </Text>
    </Box>
  );
}

// function ImageBlock({ title, desc }) {
//   return (
//     <Box sx={{ maxWidth: [`100% `, `30% `, `30% `], mr: 0, mb: [0, 3, 3] }}>
//       <Box
//         sx={{
//           mb: 3,
//           // bg: `grays.2`,
//           width: [`auto`, `400px`, `400px`],
//           height: 200,
//           // border: `solid 1px`,
//           backgroundColor: `#4F4F4F`,
//         }}
//       />
//       <Text
//         // as="h3"
//         sx={{
//           fontSize: 1,
//           mb: 1,
//           fontWeight: `400`,
//         }}
//       >
//         {title}
//       </Text>
//       <Text
//         as="p"
//         sx={{
//           fontSize: 4,
//           mr: [0, 6, 6],
//           color: `Stext`,
//           fontWeight: `400`,
//         }}
//       >
//         {desc}
//       </Text>
//     </Box>
//   );
// }

// function ClientsList() {
//   return (
//     <Container sx={{ py: `7vh` }}>
//       <Text
//         as="p"
//         // variant="blockTitle"
//         sx={{
//           fontWeight: `body`,
//           color: `grays.6`,
//           fontSize: 2,

//           // textTransform: `uppercase`,
//           letterSpacing: 0.75,
//           textAlign: [`center`, `left`, `left`],
//         }}
//       >
//         Companies we have worked with
//       </Text>
//       <Flex
//         sx={{
//           flexWrap: `wrap`,
//           // textAlign: [`center`, `left`, `left`],
//           py: 5,
//           pb: 6,
//           maxWidth: [`40ch`, `auto`, `100%`],
//           mx: `auto`,
//         }}
//       >
//         <AqueraLogo sx={{ mr: 5, width: `8ch`, mb: 4 }} />
//         <GamezyLogo sx={{ mr: 5, width: `10ch`, mb: 4 }} />
//         <AqueraLogo sx={{ mr: 5, width: `8ch`, mb: 4 }} />
//         <GamezyLogo sx={{ mr: 5, width: `10ch`, mb: 4 }} />
//         <AqueraLogo sx={{ mr: 5, width: `8ch`, mb: 4 }} />
//         <GamezyLogo sx={{ mr: 5, width: `10ch`, mb: 4 }} />
//       </Flex>
//       {/* <Box as="hr" sx={{ border: `solid 1px`, borderColor: `grays.3` }} /> */}
//     </Container>
//   );
// }

export default function Home() {
  return (
    <Layout>
      <Halo
        title="Functionary Labs"
        description="Functionary Labs is Product Design agency based in Bengaluru and Kozhikode"
        author="Functionary Labs"
        image="/home.png"
        url="https://functionary.co"
      />

      <Box sx={{ mt: 6 }}>
        <HeroAlt />
        <Container>
          <Divider
            sx={{
              color: `dividerDim`,
              // maxWidth: [`90vw`, `80vw`, `85vw`],
              marginLeft: `auto`,
              marginRight: `auto`,
            }}
          />
        </Container>
        {/* <Box
          as="hr"
          style={{
            height: `1px`,
            color: `base`,
          }}
        /> */}
        <Box sx={{ bg: `base`, minHeight: `70vh`, pt: `6vh`, pb: `8vh` }}>
          <Container>
            <Box sx={{ pb: [5, 6, 6], maxWidth: [`70%`, `100%`, `100%`] }}>
              <Text as="h2" variant="sectionTitle">
                How we help
              </Text>
              <Text
                as="p"
                sx={{ fontSize: 3, color: `dimText`, lineHeight: `heading` }}
              >
                How we can accelerate growth for your product.
              </Text>
            </Box>
            <Box sx={{ pb: 0, pt: `0vh` }}>
              <Flex
                sx={{
                  flexWrap: `wrap`,
                  flexDirection: [`column`, `row`, `row`],
                  justifyContent: `space-between`,
                  maxWidth: [`70%`, `100%`, `100%`],
                }}
              >
                <CardBlock
                  color="#1971c2"
                  stemColor="#fff3bf"
                  showStem={false}
                  lineLength={1}
                  strokeWidth={0.5}
                  title="Design"
                  desc="Research-driven design narratives for brands and user experiences."
                />
                <CardBlock
                  color="#1971c2"
                  lineLength={1.5}
                  strokeWidth={0.5}
                  showStem
                  stemColor="#a5d8ff"
                  title="Build"
                  desc="Bespoke technology solutions tailored to your product's needs."
                />
                <CardBlock
                  color="#1971c2"
                  lineLength={7}
                  showStem
                  strokeWidth={0.5}
                  stemColor="#1971c2"
                  title="Operate"
                  desc="Deploying infrastructure strategies to navigate the complexities of growth."
                />
              </Flex>
            </Box>
            {/* <Box as="hr" sx={{ border: `solid 1px`, borderColor: `grays.3` }} /> */}
          </Container>
          {/* <Container sx={{ py: 5, pt: [0, `12vh`, `12vh`], pb: `7vh` }}>
            <Box sx={{ pb: 5 }}>
              <Text as="h1" variant="sectionTitle" sx={{ pb: 0 }}>
                What do we do?
              </Text>
              <Text as="p" sx={{ fontSize: 3 }}>
                Our team works with product teams at multiple stages of their
                product journey
              </Text>
            </Box>
            <Box sx={{ pb: 0, pt: [0] }}>
              <Flex
                sx={{
                  flexWrap: `wrap`,
                  flexDirection: [`column`, `row`, `row`],
                  alignItems: `flex-start`,
                  gap: [`60px`, `100px`, `120px`],
                }}
              >
                <ImageBlock
                  title="Product Design"
                  desc="Real-time Occupancy & Seat Management - CosmicEye"
                />
                <ImageBlock
                  title="Product Design"
                  desc="Design System for an Identity Management Solution"
                />
              </Flex>
            </Box>
          </Container> */}
        </Box>
        {/* <Box sx={{ bg: `grays.1`, py: 0 }}>
          <ClientsList />
        </Box>
        <Box sx={{ bg: `grays.2`, py: 4 }}>
          <Container sx={{ py: 0, pb: 5 }}>
            <Text as="h1" variant="sectionTitle" sx={{ color: `primary` }}>
              Lets start talking
            </Text>
            <Text as="p" sx={{ fontSize: [2, 2, 3] }}>
              Connect with our team to discuss your next project
            </Text>
          </Container>
        </Box> */}
        {/* <Divider
          sx={{
            color: `dividerDim`,
            // maxWidth: [`90vw`, `80vw`, `85vw`],
            // marginLeft: `auto`,
            // marginRight: `auto`,
          }}
        /> */}
        <TalkBlock />
      </Box>
    </Layout>
  );
}
